import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/api";
import ProductCard from "../components/ProductCard";

const TITLES = { tees: "Tees", headwear: "Headwear", hoodies: "Hoodies" };

const Category = () => {
  const { pathname } = useLocation();
  const slug = pathname.replace(/^\//, "").split("/")[0];
  const title = TITLES[slug] || slug;
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api
      .get("/products", { params: { category: slug } })
      .then((r) => setProducts(r.data))
      .finally(() => setLoading(false));
  }, [slug]);

  return (
    <div className="section-pad py-16" data-testid={`category-page-${slug}`}>
      <h1 className="font-blackletter mb-16 text-center" style={{ fontSize: "clamp(4.5rem, 14vw, 11rem)" }}>
        {title.toLowerCase()}
      </h1>
      {loading ? null : products.length === 0 ? (
        <div className="text-sm text-black/40">No pieces.</div>
      ) : (
        <div className="grid gap-10 md:gap-14 sm:grid-cols-2 lg:grid-cols-3" data-testid="category-grid">
          {products.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      )}
    </div>
  );
};

export default Category;
